module.exports = __webpack_public_path__ + "20b1df0f24898ae8b9b35b3d39e9078e.png";